import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { createFaq } from "store/faqSlice";
import { useHistory } from "react-router-dom";


export default function FaqCreate({ color }) {
const dispatch = useDispatch();
const history = useHistory();


const [question, setQuestion] = useState("");
const [answer, setAnswer] = useState("");
const [isActive, setIsActive] = useState(true);


const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
        question,
        answer,
        is_active: isActive,
    };


    dispatch(createFaq(data)).then(() => {
    history.push("/admin/faq");
    });
};

return (
    <div
    className={
    "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
    (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
    }
    >
        <div className="max-w-4xl mx-auto p-6 bg-white shadow rounded">
            <h2 className="text-xl font-semibold mb-4">Create FAQ</h2>


            <form onSubmit={handleSubmit} className="space-y-4">
            {/* Question */}
            <div>
            <label className="block text-sm font-medium mb-1">Question</label>
            <input
            type="text"
            className="w-full border px-3 py-2 rounded"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            required
            />
            </div>


            {/* Answer */}
            <div>
            <label className="block text-sm font-medium mb-1">Answer</label>
            <textarea
            rows="5"
            className="w-full border px-3 py-2 rounded"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            required
            />
            </div>
            {/* Active */}
            <div className="flex items-center space-x-2">
            <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
            />
            <label>Is Active</label>
            </div>


            {/* Buttons */}
            <div className="flex space-x-2">
            <button
            type="submit"
            className="bg-lightBlue-600 text-white px-4 py-2 rounded"
            >
            Create
            </button>
            <button
            type="button"
            onClick={() => history.push("/admin/faq")}
            className="bg-gray-300 px-4 py-2 rounded"
            >
            Cancel
            </button>
            </div>
            </form>
        </div>
    </div>
);
}


FaqCreate.defaultProps = { color: "light" };
FaqCreate.propTypes = { color: PropTypes.oneOf(["light", "dark"]) };